/**
 * Public demo detection that works even when REACT_APP_DEMO_MODE was not
 * inlined at build time (e.g. wrong CI env on demo.qawaem.live).
 */

export function isBrowserPublicDemoHost() {
  if (typeof window === 'undefined') return false;
  const h = String(window.location.hostname || '').toLowerCase();
  if (!h) return false;
  if (h === 'demo.qawaem.live') return true;
  if (h === 'qawaem-demo.pages.dev') return true;
  if (h.endsWith('.qawaem-demo.pages.dev')) return true;
  return false;
}

/** Build-time demo flag OR known demo hostname in the browser */
export function isCloudDemoRuntime() {
  if (process.env.REACT_APP_DEMO_MODE === 'true') return true;
  return isBrowserPublicDemoHost();
}
